import React, { useState } from "react";
import LeafletMap from "./LeafletMap";
import storeData from "./stores.json";
import "leaflet/dist/leaflet.css";
import "./App.css";

function App() {
  const [mapCenter, setMapCenter] = useState([39.8283, -98.5795]); // US center
  const [zoomLevel, setZoomLevel] = useState(4);
  const [markers] = useState(storeData);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  // Calculate distance using Haversine formula
  const getDistanceMiles = (lat1, lon1, lat2, lon2) => {
    const R = 3958.8; // Earth radius in miles
    const toRad = (angle) => (angle * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  // Handle marker clicks (Zoom + Center on Clicked Marker)
  const handleMarkerClick = (marker) => {
    setSelectedStoreId(marker.id);
    setMapCenter([marker.latitude, marker.longitude]);
    setZoomLevel(4);
  };

  // Find the nearest store to given coordinates
  const findNearestStore = (latitude, longitude) => {
    let nearestStore = null;
    let minDistance = Infinity;

    markers.forEach((store) => {
      const dist = getDistanceMiles(latitude, longitude, store.latitude, store.longitude);
      if (dist < minDistance) {
        minDistance = dist;
        nearestStore = store;
      }
    });

    if (nearestStore) {
      setMapCenter([nearestStore.latitude, nearestStore.longitude]);
      setZoomLevel(3);
      setSelectedStoreId(nearestStore.id);
    }

    setLoading(false);
  };

  // Handle "Use My Location"
  const handleFindMe = () => {
    if (!navigator.geolocation) {
      alert("Your browser does not support geolocation.");
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        findNearestStore(position.coords.latitude, position.coords.longitude);
      },
      (error) => {
        console.error("Geo error:", error);
        setLoading(false);
        setShowLocationPopup(true);
      }
    );
  };

  // Handle ZIP Code / Address Search using Nominatim (OpenStreetMap)
  const handleSearch = async () => {
    if (!searchInput.trim()) return;

    setLoading(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchInput)}&countrycodes=US&limit=1`
      );
      const data = await response.json();

      if (data.length > 0) {
        const { lat, lon } = data[0];
        findNearestStore(parseFloat(lat), parseFloat(lon));
      } else {
        alert("Address not found. Please try again.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Geocoding error:", error);
      setLoading(false);
    }
  };

  return (
    <div className="App">
      {/*<h1 className="heading-style-h1">Find a Big Air</h1>  */}

      <div className="search-container">
        <button className="use-location-btn" onClick={handleFindMe}>
          Use My Location
        </button>
        <div className="search-box">
        <input
          type="text"
          
          className="search-input"
          placeholder="Enter ZIP Code or Address"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          />
        <button className="search-btn" onClick={handleSearch}>
          Search
        </button>
          </div>
      </div>

      {showLocationPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <h2>Enable Location Services</h2>
            <p>You need to enable location access in your browser settings.</p>
            <ul>
              <li>🔹 On Chrome: Go to Settings → Privacy & Security → Site Settings → Location</li>
              <li>🔹 On Safari (iPhone): Settings → Privacy → Location Services</li>
              <li>🔹 On Firefox: Click the lock icon in the address bar</li>
            </ul>
            <button className="close-btn" onClick={() => setShowLocationPopup(false)}>Close</button>
          </div>
        </div>
      )}

      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <LeafletMap
        center={mapCenter}
        zoom={zoomLevel}
        markers={markers}
        selectedStoreId={selectedStoreId}
        onMarkerClick={handleMarkerClick}
      />
    </div>
  );
}

export default App;
